import { render, staticRenderFns } from "./requests-filter.vue?vue&type=template&id=1b8bcdd9&"
import script from "./requests-filter.vue?vue&type=script&lang=js&"
export * from "./requests-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports